import { useAgentByContextQuery } from './enrollment-types';

export const useAgent = () => {
  const { data } = useAgentByContextQuery();
  return data?.agentByContext;
}
